export default {
  expirationDateLabel: {
    id: 'step_description_mobile_plan_expiration_date_label',
    defaultMessage: 'Offre flash jusqu’au 30/04/2025.',
  },
}
